const a = 9, E = 4, _ = "Previous Page", g = "Next Page", T = "...", c = "page";
function o(e, i, f = c) {
  if (!e) return;
  if (i === Number(e.searchParams.get(f))) return `${e.pathname}${e.search}`;
  const n = new URL(e);
  return i === 1 ? (n.searchParams.delete(f), `${n.pathname}${n.search}`) : (n.searchParams.set(f, i.toString()), `${n.pathname}${n.search}`);
}
function m(e) {
  if (!(!e || typeof e != "string"))
    return new URL(
      e,
      typeof window < "u" ? window.location.origin : "https://example.com"
    );
}
function p({
  currentPage: e,
  totalPages: i,
  screen: f = "xxs",
  url: n
}) {
  const x = f === "xxs" ? 4 : 9, t = f === "xxs", s = [
    { page: e, href: o(n, e), screen: t ? "xxs" : "m" }
  ];
  for (let h = 0; h < x; h++) {
    let r = Number(s[0].page) - 1;
    if (r > 0 && (s.unshift({
      page: r,
      href: o(n, r),
      screen: t ? "xxs" : "m"
    }), s.length === x) || (r = Number(s[s.length - 1].page) + 1, r < i + 1 && (s.push({
      page: r,
      href: o(n, r),
      screen: t ? "xxs" : "m"
    }), s.length === x)))
      break;
  }
  if (s[0] = { page: 1, href: o(n, 1), screen: t ? "xxs" : "m" }, s[s.length - 1] = {
    page: i,
    href: o(n, i),
    screen: t ? "xxs" : "m"
  }, s.length > 1 && i > 4) {
    (s[1].page !== 2 && s[1].page !== e || t && e > 2) && (s[1] = { page: -1, href: void 0, isEllipsis: !0, screen: t ? "xxs" : "m" }), (s[s.length - 2].page !== i - 1 && s[s.length - 2].page !== e || t && e < i - 1) && (s[s.length - 2] = {
      page: -2,
      href: void 0,
      isEllipsis: !0,
      screen: t ? "xxs" : "m"
    });
    const h = s.some(({ page: r }) => r === e);
    t && !h && s.splice(2, 0, {
      page: e,
      href: o(n, e),
      screen: t ? "xxs" : "m"
    });
  }
  return s;
}
function d({
  currentPage: e,
  totalPages: i,
  baseURL: f = ""
}) {
  const n = m(f);
  if (i <= 1)
    return {
      items: [
        { page: 1, href: o(n, 1), screen: "m" },
        { page: 1, href: o(n, 1), screen: "xxs" }
      ],
      prevURL: void 0,
      nextURL: void 0
    };
  const x = p({
    currentPage: e,
    totalPages: i,
    url: n,
    screen: "m"
  }), t = p({
    currentPage: e,
    totalPages: i,
    url: n,
    screen: "xxs"
  });
  return {
    items: [...x, ...t],
    prevURL: e === 1 ? void 0 : o(n, e - 1),
    nextURL: e === i ? void 0 : o(n, e + 1)
  };
}
export {
  T as ELLIPSES,
  a as MAX_BUTTONS_DESKTOP,
  E as MAX_BUTTONS_MOBILE,
  g as NEXT_PAGE,
  c as PAGE_PARAM_NAME,
  _ as PREVIOUS_PAGE,
  p as generateButtonArray,
  d as getPaginationItems
};
